import React from 'react';
import SingleControlCustom from './SingleControlCustom';

export const getRenderControl = (renderProps) => {
  return (props) => {
    return (
      <SingleControlCustom
        {...props}
        {...renderProps}
      />
    );
  };
};
